import React, { useState } from 'react';
import { gallery } from '../data/mockData';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section id="gallery" className="section-padding bg-page relative z-10">
      <div className="container mx-auto px-5 md:px-10">
        {/* Section Header */}
        <div className="text-center mb-16 scroll-reveal">
          <h2 className="heading-2 mb-6 gradient-text">הגלריה שלנו</h2>
          <p className="body-medium text-secondary max-w-2xl mx-auto">
            הציצו פנימה והכירו את המתקנים המתקדמים והאווירה המיוחדת שלנו
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="gallery-grid">
          {gallery.map((item, index) => (
            <div 
              key={item.id}
              className="gallery-item scroll-reveal-scale"
              style={{ animationDelay: `${index * 0.08}s` }}
              onClick={() => setSelectedImage(item)}
            >
              <img 
                src={item.image}
                alt={item.alt}
                className="gallery-image"
              />
              <div className="gallery-overlay">
                <span className="text-primary font-semibold text-lg">
                  {item.alt}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div 
          className="lightbox-overlay"
          onClick={() => setSelectedImage(null)}
        >
          <div className="lightbox-content">
            <button 
              onClick={() => setSelectedImage(null)}
              className="lightbox-close"
              aria-label="Close"
            >
              ✕
            </button>
            <img 
              src={selectedImage.image}
              alt={selectedImage.alt}
              className="lightbox-image"
            />
            <p className="text-primary text-center mt-4 body-medium">
              {selectedImage.alt}
            </p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
